import React, { useEffect, useState } from 'react'
import { t } from '../i18n'

/**
 * Chrome de modo Comparar: guía breve (auto-oculta) + chip fijo para salir.
 * Visible mientras compareMode esté ON.
 */
function CompareModeGuide({ open, guideOpen, onDismiss, onExit }) {
  const [tipVisible, setTipVisible] = useState(!!guideOpen)

  useEffect(() => {
    if (!open || !guideOpen) {
      setTipVisible(false)
      return undefined
    }
    setTipVisible(true)
    const timer = setTimeout(() => {
      setTipVisible(false)
      if (typeof onDismiss === 'function') onDismiss()
    }, 6000)
    return () => clearTimeout(timer)
  }, [open, guideOpen, onDismiss])

  if (!open) return null

  const showTip = !!guideOpen && tipVisible

  return (
    <div
      className="udv-compare-mode-chrome"
      role="status"
      style={{
        position: 'absolute',
        left: '50%',
        top: 12,
        transform: 'translateX(-50%)',
        zIndex: 40,
        maxWidth: 'min(560px, 94%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        pointerEvents: 'none',
      }}
    >
      {showTip ? (
        <div
          className="udv-compare-mode-guide"
          style={{
            padding: '10px 14px',
            borderRadius: 6,
            background: 'rgba(24, 28, 36, 0.92)',
            border: '1px solid rgba(196, 165, 116, 0.45)',
            color: '#e8e6e3',
            fontSize: 13,
            lineHeight: 1.35,
            boxShadow: '0 4px 18px rgba(0,0,0,0.35)',
            pointerEvents: 'auto',
            display: 'flex',
            gap: 10,
            alignItems: 'flex-start',
          }}
        >
          <span style={{ flex: 1 }}>{t('relatedStudies.compareGuide')}</span>
          <button
            type="button"
            onClick={() => {
              setTipVisible(false)
              if (typeof onDismiss === 'function') onDismiss()
            }}
            aria-label={t('common.close')}
            style={{
              flex: '0 0 auto',
              border: 'none',
              background: 'transparent',
              color: '#c4a574',
              cursor: 'pointer',
              fontSize: 16,
              lineHeight: 1,
              padding: 0,
            }}
          >
            ×
          </button>
        </div>
      ) : null}

      <button
        type="button"
        className="udv-compare-mode-exit-chip"
        onClick={() => {
          if (typeof onExit === 'function') onExit()
        }}
        title={t('relatedStudies.compareModeOff')}
        aria-label={t('relatedStudies.compareExitAria')}
        style={{
          pointerEvents: 'auto',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 12px',
          borderRadius: 999,
          border: '1px solid rgba(100, 181, 246, 0.65)',
          background: 'rgba(30, 60, 100, 0.92)',
          color: '#e3f2fd',
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: 0.2,
          cursor: 'pointer',
          boxShadow: '0 2px 12px rgba(0,0,0,0.35)',
          whiteSpace: 'nowrap',
        }}
      >
        <span
          aria-hidden="true"
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: '#64b5f6',
            boxShadow: '0 0 0 2px rgba(100,181,246,0.35)',
          }}
        />
        <span>{t('relatedStudies.compareExitChip')}</span>
        <span style={{ opacity: 0.85, fontWeight: 600 }}>✕</span>
      </button>
    </div>
  )
}

export default CompareModeGuide
